import { render, staticRenderFns } from "./DmHeurekaConsent.vue?vue&type=template&id=71164bca&scoped=true&"
import script from "./DmHeurekaConsent.vue?vue&type=script&lang=js&"
export * from "./DmHeurekaConsent.vue?vue&type=script&lang=js&"
import style0 from "./DmHeurekaConsent.vue?vue&type=style&index=0&id=71164bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71164bca",
  null
  
)

export default component.exports